import Scriba from 'react-scriba';

export class DataOperation_CycleCommercial {
    static _chargementCycleCommercial(idCycleCommercial, idOperation) {
        let objet = {
            "idCycleCommercial": idCycleCommercial,
            "idOperation": idOperation
        };
        var url = "api/Get/GetCycleCommercial";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _enregistrementCycleCommercial(idCycleCommercial, idOperation, operation) {
        let objet = {
            "idCycleCommercial": idCycleCommercial,
            "idOperation": idOperation,
            "operation": operation
        };
        var url = "api/MAJDonnees/EnregistrementCycleCommercial";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}